import $ from "jquery";
import "bootstrap/js/dist/tab";
import placesAutoComplete from "google/places-auto-complete";
import pageData from "common/page-data";

// Set up Google autocomplete in the search modals
if (placesAutoComplete && document.querySelector(".js-video-profile-search-form-city-state")) {
  placesAutoComplete.initializeCityState(
    ".js-video-profile-search-form-city-state",
    null,
    pageData.get("currentCountry")
  );
}

if (placesAutoComplete && document.querySelector(".js-video-profile-search-form-address")) {
  placesAutoComplete.initializeAddress(
    ".js-video-profile-search-form-address",
    null,
    pageData.get("currentCountry")
  );
}

const hashActions = {
  "#advertise-property": { tab: "#tab-advertise-property" },
  "#advertise-brand": {
    tab: "#tab-advertise-brand",
    onShown: () => $("#tab-advertise-brand #targetLocal").prop("checked", true)
   },
  "#advertise-referral": {
    tab: "#tab-advertise-brand",
    onShown: () => $("#tab-advertise-brand #targetSphere").prop("checked", true)
  }
};

const activateTabFromHash = () => {
  const hash = window.location.hash;
  const action = hashActions[hash];

  if (action) {
    const tabLink = $(`#video-product-nav-tabs a[data-target="${action.tab}"]`);
    if (tabLink.length) {
      const isAlreadyActive = tabLink.hasClass('active');

      if (action.onShown) {
        if (isAlreadyActive) {
          action.onShown();
        } else {
          tabLink.one('shown.bs.tab', action.onShown);
        }
      }

      if (!isAlreadyActive) {
        tabLink.tab('show');
      }
    }
  }
};

$(document).on("click", "a[href*='#advertise-']", (e) => {
  const targetHash = e.currentTarget.hash;
  const currentPath = window.location.pathname;
  const targetPath = e.currentTarget.pathname;
  const hasAnchor = window.location.hash.length > 0;

  if (currentPath === targetPath && hasAnchor && hashActions[targetHash]) {
    e.preventDefault();
    window.scrollTo(0, 0);
    window.location.href = e.currentTarget.href;
    window.location.reload();
  }
});

$(document).ready(activateTabFromHash);

$("#video-product-nav-tabs a").on("shown.bs.tab", (e) => {
  $("#video-product-nav-tabs a").removeClass("btn-primary");
  $(e.target).addClass("btn-primary");
});
